import { PageInfo } from '@/types'
import { useEffect, useRef, useState } from 'react'

interface Props {
  pageInfo: PageInfo | undefined
}

export const usePageInfo = ({ pageInfo }: Props) => {
  const [queryPageInfo, setQueryPageInfo] = useState<PageInfo>({ hasPreviousPage: false, hasNextPage: true })
  const pageInfoRef = useRef<PageInfo>(null)
  pageInfoRef.current = queryPageInfo

  useEffect(() => {
    if (!pageInfo) return

    setQueryPageInfo({ ...pageInfo })
  }, [pageInfo])

  return {
    moreToFetch: pageInfoRef.current?.hasNextPage,
    pageInfo: pageInfoRef,
  }
}
